import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LocationService } from '../../../core/location/location.service';
import { Roles, UserService } from 'src/app/core/user/user.service';
import { AuthTokenStorageService } from '../../../core/security/auth-token-storage.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  hasError = false;

  constructor(
    private router: Router,
    private locationService: LocationService,
    private userService: UserService,
    private authTokenStorageService: AuthTokenStorageService,
  ) {}

  ngOnInit() {
    this.loadLocations();
  }

  loadLocations() {
    this.hasError = false;
    this.locationService.getCachedUserOpwLocationsWithStats().subscribe({
      next: (locationsWithStats) => {
        console.log('Available locations:', locationsWithStats);
        if (this.userService.hasRole(Roles.EXTERNAL_INSTALLER)) {
          console.log(
            'Case: EXTERNAL_INSTALLER - Redirecting to check page for location:',
            locationsWithStats[0].location.locationId,
          );
          this.router.navigate(['/locations/' + locationsWithStats[0].location.locationId + '/check']);
        } else if (locationsWithStats.length === 1) {
          console.log('Case: Single location - Redirecting to location:', locationsWithStats[0].location.locationId);
          this.router.navigate(['/locations/' + locationsWithStats[0].location.locationId]);
        } else if (locationsWithStats.length > 1) {
          console.log(
            'Case: Multiple locations - Redirecting to sites page, total locations:',
            locationsWithStats.length,
          );
          this.router.navigate(['/sites']);
        } else {
          console.log('Case: No locations - Redirecting to not-authorized page');
          this.router.navigate(['/not-authorized']);
        }
      },
      error: (error) => {
        console.error('Error loading locations:', error);
        this.hasError = true;
      },
    });
  }

  retry() {
    this.loadLocations();
  }

  onLogout() {
    this.authTokenStorageService.logout();
    this.router.navigate(['/']);
  }
}
